/* Maison Byōbu · prix « Tête de lit dès X € » des cartes et du héros (16/10/2026, charte règle 4).
   Le prix normal (format 200 × 130 cm, marges de pose comprises, variante la moins chère) est calculé par Liquid
   (snippets/mb-prix-tete.liquid, data-mb-pt en centimes). Ici, seulement : si la promotion window.mbOffre est active
   (assets/mb-offre.js, source unique), on affiche le prix remisé et le prix normal barré. Sinon, ou sans JavaScript,
   le prix normal seul : le prix barré disparaît de lui-même après le 26/10 à 23 h 59. Le moteur de prix n'est pas lu ni modifié.
   Ce script est chargé dans le <head> (différé), donc AVANT assets/mb-offre.js : il attend DOMContentLoaded,
   qui n'arrive qu'après l'exécution de tous les scripts différés. */
(() => {
  const eur = (c) => new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(Math.round(c / 100)) + ' €';
  const maj = () => {
    const o = window.mbOffre;
    const on = !!(o && typeof o.active === 'function' && o.active() && o.pct > 0);
    document.querySelectorAll('[data-mb-pt]').forEach((el) => {
      const c = Number(el.dataset.mbPt);
      if (!(c > 0)) return;
      const prix = el.querySelector('.mb-pt__prix');
      const barre = el.querySelector('.mb-pt__barre');
      const au = el.querySelector('.mb-pt__au');
      if (on) {
        const p = c - Math.floor((c * o.pct) / 100);
        if (prix) prix.textContent = eur(p);
        if (barre) { barre.textContent = eur(c); barre.hidden = false; }
        if (au) au.hidden = false;
      } else {
        if (prix) prix.textContent = eur(c);
        if (barre) barre.hidden = true;
        if (au) au.hidden = true;
      }
    });
    /* 16/10 soir (brief « site qui convainc ») : prix d'appel « dès 58,65 €/m² » barré 69 € + pastille « −15 % »
       (snippets/mb-prix-appel.liquid, data-mb-pm = prix au m² de la variante la moins chère, en centimes).
       Hors promotion : « dès 69 €/m² », sans barré ni pastille. Affichage seul, le moteur de prix n'est pas lu. */
    const m2 = (c) => new Intl.NumberFormat('fr-FR', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(c / 100);
    document.querySelectorAll('[data-mb-pm]').forEach((el) => {
      const c = Number(el.dataset.mbPm);
      if (!(c > 0)) return;
      const prix = el.querySelector('.mb-pm__prix');
      const barre = el.querySelector('.mb-pm__barre');
      const pastille = el.querySelector('.mb-pm__pastille');
      if (on) {
        const p = Math.round(c * (100 - o.pct) / 100);
        if (prix) prix.textContent = `${m2(p)} €/m²`;
        if (barre) { barre.textContent = `${m2(c)} €`; barre.hidden = false; }
        if (pastille) { pastille.textContent = `−${o.pct} %`; pastille.hidden = false; }
      } else {
        if (prix) prix.textContent = `${m2(c)} €/m²`;
        if (barre) barre.hidden = true;
        if (pastille) pastille.hidden = true;
      }
    });
    document.documentElement.classList.toggle('mb-promo-on', on);
  };
  document.addEventListener('DOMContentLoaded', maj);
  window.addEventListener('load', maj);
  if (document.readyState === 'complete') maj();
  setInterval(maj, 60000);
})();
